import React from 'react';
import OMSComponent from 'components/webinar/orgasmic-manifesting-system';

export default function OMS() {
  return <OMSComponent />;
}
